import { render } from "./link-gallery.vue?vue&type=template&id=6ba00bec"
import script from "./link-gallery.vue?vue&type=script&lang=js"
export * from "./link-gallery.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__